import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import MasterAPI from 'service/master';

const initialState = {
    darkMode: false,
    menuTheme: 3, // 1=light, 2=dark, 3=primary
    headerTheme: 0, // like up
    menuFadeLg: false,
    menuFadeSm: false,
    themeSettingModal: { show: false, panelSettings: true },
    activePanelRoute: null,
    cropSizes: {
        pending: true
    }
}

export const getCropSizes = createAsyncThunk(
    'getCropSizes',
    async () => {
        const res = await MasterAPI({
            url: "/api/upload/crop_size",
            method: "GET"
        });

        return res.data.map(size => `${size.width}x${size.height}`);
    }
)

export const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setDarkMode: (state, action) => {
            state.darkMode = action.payload;
            state.menuTheme = action.payload ? 2 : 3;
        },
        toggleDarkMode: state => {
            state.darkMode = !state.darkMode;
            state.menuTheme = state.darkMode ? 2 : 3;
        },
        setMenuTheme: (state, action) => {
            state.menuTheme = action.payload;
        },
        setHeaderTheme: (state, action) => {
            state.headerTheme = action.payload;
        },
        setThemeSettingModal: (state, action) => {
            state.themeSettingModal = action.payload;
        },
        toggleMenuFadeLg: state => {
            state.menuFadeLg = !state.menuFadeLg;
        },
        toggleMenuFadeSm: state => {
            state.menuFadeSm = !state.menuFadeSm;
        },
        setMenuFadeSm: (state, action) => {
            state.menuFadeSm = action.payload;
        },
        resetTheme: state => {
            return {
                ...state,
                darkMode: false,
                menuTheme: 3,
                headerTheme: 0
            }
        },
        setActivePanelRoute: (state, action) => {
            state.activePanelRoute = action.payload;
        }
    },
    extraReducers: builder => {
        builder.addCase(getCropSizes.pending, state => {
            state.cropSizes = {
                data: [],
                pending: true,
                error: false
            }
        })

        builder.addCase(getCropSizes.fulfilled, (state, action) => {
            state.cropSizes = {
                data: action.payload,
                pending: false,
                error: false
            }
        })

        builder.addCase(getCropSizes.rejected, state => {
            state.cropSizes = {
                data: [],
                pending: false,
                error: true
            }
        })
    }
})

export const {
    setDarkMode,
    toggleDarkMode,
    setMenuTheme,
    setHeaderTheme,
    setThemeSettingModal,
    toggleMenuFadeLg,
    toggleMenuFadeSm,
    resetTheme,
    setActivePanelRoute,
    setMenuFadeSm
} = themeSlice.actions

export default themeSlice.reducer;